import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { createZone, editZone, fetchZoneDetail, fetchWarehouseBins, generateBin, createBin, editBins, editLevels } from '../../actions/zones_actions';
import { setValue } from '../../actions/products_actions';
import ZoneForm from '../../components/Inventories/zoneForm';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';

const validate = (values) => {
  const errors = {};

  if (!values.Name) {
    errors.Name = 'Required';
  }

  if (values.Name) {
    const str = values.Name.replace(/\s/g, '');
    if (str !== values.Name) {
      errors.Name = 'Please remove all spaces.';
    }
  }
  return errors;
};

let zoneForm = reduxForm({
  form: 'zoneForm',
  validate,
})(ZoneForm);

const selector = formValueSelector('zoneForm');

function mapStateToProps(state) {
  const zone_num = selector(state, 'zone_num');
  const description = selector(state, 'description');
  const section_num = selector(state, 'section_num');
  const bin_num = selector(state, 'bin_num');
  const binDescription = selector(state, 'binDescription');
  const levelDescription = selector(state, 'levelDescription');
  return {
    zone_num,
    description,
    section_num,
    bin_num,
    binDescription,
    levelDescription,
    currentWarehouse: state.warehouses.currentWarehouse,
    currentWarehouseDetail: state.warehouses.currentWarehouseDetail,
    currentZone: state.zones.currentZone,
    currentZoneDetail: state.zones.currentZoneDetail,
    detailIsLoading: state.zones.detailIsLoading,
    detailError: state.zones.detailError,
    initialValues: state.zones.currentZoneDetail,
    isCreating: state.zones.isCreating,
    createError: state.zones.createError,
    created: state.zones.created,
    binCreateError: state.zones.binCreateError,
    binCreated: state.zones.binCreated,
    levelCreateError: state.zones.levelCreateError,
    levelCreated: state.zones.levelCreated,
    isEditing: state.zones.isEditing,
    editError: state.zones.editError,
    edited: state.zones.edited,
    initialValues: state.zones.currentZone,
    currentBin: state.zones.currentBin,
    currentLevel: state.zones.currentLevel,
  };
}

export default connect(mapStateToProps, {
  change,
  setDefaultOfForm,
  setValue,
  editLevels,
  editBins,
  createBin,
  generateBin,
  fetchWarehouseBins,
  createZone,
  editZone,
  fetchZoneDetail,
})(zoneForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/zoneForm.jsx